"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useId } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrophy } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip";
import useIsMobileDevice from "@/hooks/isMobileDevice";

// Tooltip styles - extracted to prevent re-creation on each render
const TOOLTIP_STYLES = {
  backgroundColor: "#1F2937",
  color: "white",
  padding: "6px 12px",
  fontSize: "12px",
  zIndex: 50,
  boxShadow: "0 4px 16px 0 rgba(0,0,0,0.30), 0 2px 8px 0 rgba(55,55,62,0.25)"
} as const;
interface ProfileWinnerBadgeProps {
  readonly winCount: number;
  readonly tooltipId?: string | undefined;
  readonly onBadgeClick?: (() => void) | undefined;
}
export const ProfileWinnerBadge: React.FC<ProfileWinnerBadgeProps> = t0 => {
  const $ = _c(19);
  const {
    winCount,
    tooltipId: t1,
    onBadgeClick
  } = t0;
  const tooltipId = t1 === undefined ? "winner-badge" : t1;
  const isMobile = useIsMobileDevice();
  const id = useId();
  const uniqueTooltipId = `${tooltipId}-${id}`;
  const [isTooltipOpen, setIsTooltipOpen] = React.useState(false);
  const dataTooltipId = !isMobile ? uniqueTooltipId : undefined;
  if (winCount === 0) {
    return null;
  }
  let t2;
  if ($[0] !== onBadgeClick) {
    t2 = e => {
      e.preventDefault();
      e.stopPropagation();
      setIsTooltipOpen(false);
      onBadgeClick?.();
    };
    $[0] = onBadgeClick;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsTooltipOpen(true);
    t4 = () => setIsTooltipOpen(false);
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  const t5 = `View ${winCount} winning artwork${winCount === 1 ? "" : "s"}`;
  let t6;
  if ($[4] !== dataTooltipId) {
    t6 = dataTooltipId && {
      "data-tooltip-id": dataTooltipId
    };
    $[4] = dataTooltipId;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FontAwesomeIcon icon={faTrophy} className={"tw-w-3 tw-h-3 md:tw-w-2.5 md:tw-h-2.5 tw-text-amber-400 tw-flex-shrink-0\n        desktop-hover:hover:tw-text-amber-300/90"} />;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t2 || $[8] !== t5 || $[9] !== t6) {
    t8 = <button onClick={t2} onMouseEnter={t3} onMouseLeave={t4} className={"tw-w-6 tw-h-6 md:tw-w-5 md:tw-h-5 tw-outline-none tw-ring-0 tw-inline-flex tw-items-center tw-justify-center\n       tw-rounded-md tw-border tw-border-solid tw-border-amber-400/20\n        tw-bg-amber-400/10 tw-text-amber-300 tw-text-xs\n        tw-shadow-[inset_0_0_2px_rgba(255,255,255,0.08),0_1px_4px_rgba(0,0,0,0.25)]\n        tw-transition-all tw-duration-200\n        desktop-hover:hover:tw-border-amber-400/30\n        desktop-hover:hover:tw-bg-amber-900/30\n        desktop-hover:hover:tw-scale-[1.05]\n        desktop-hover:hover:tw-shadow-[inset_0_0_3px_rgba(255,255,255,0.12),0_2px_6px_rgba(0,0,0,0.3)]\n        focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-amber-400/50 focus-visible:tw-ring-offset-2"} aria-label={t5} {...t6}>{t7}</button>;
    $[7] = t2;
    $[8] = t5;
    $[9] = t6;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== isMobile || $[12] !== isTooltipOpen || $[13] !== uniqueTooltipId || $[14] !== winCount) {
    t9 = !isMobile && <Tooltip id={uniqueTooltipId} place="top" positionStrategy="absolute" content={`View ${winCount} winning artwork${winCount === 1 ? "" : "s"}`} delayShow={300} opacity={1} style={TOOLTIP_STYLES} isOpen={isTooltipOpen} />;
    $[11] = isMobile;
    $[12] = isTooltipOpen;
    $[13] = uniqueTooltipId;
    $[14] = winCount;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};